$(function() {
  var $overlay = $('#loading-overlay')

  $('body')
    .on('app.loading', function() {
      $overlay.addClass('active')
    })
    .on('app.loaded', function() {
      $overlay.removeClass('active')
    })
})
